const formatDate = (date: Date): string => {
  return new Date(date).toLocaleDateString()
}

const getMapStatusLabel = (isPublic: boolean): string => {
  return isPublic ? 'Public' : 'Private'
}

const getPreviewText = (hasImage: boolean): string => {
  return hasImage ? '' : 'No preview available'
}

export { formatDate, getMapStatusLabel, getPreviewText }
